// Para generar el binario con la configuración de enviroment.ts, usa "npm run build"
// Para generar el binario con la configuración de enviroment.prod.ts, usa "npm run build:prod"
// Para generar el binario con la configuración de enviroment.testing.ts, usa "npm run build:test"
export const environment = {
  production: true,
  API_URI: '//rrhh.api.qa.iturriapp.com/api/rest/',
  PUBLIC_URI: '//rrhh.api.qa.iturriapp.com/public/rest/',
  CDN_BASE: '//rrhh.api.qa.iturriapp.com/',
  API_ITURRIAPP: '//api.iturriapp.com/public',
  CDN_CLOUDINARY: '',
  FREE_ACCESS: true,
  PARAM: {
    ACTIVO: '1',
    INACTIVO: '0',
    SI: '1',
    NO: '0',
    TODOS: '-1',
    VACIO: ''
  },
  HTTP_RESPONSE: {
    SUCCESS: 1,
    WARNING: 2,
    ERROR: 3,
    INFO: 4,
    PERMISION_ERROR: 401,
    CODE_NOT_DEFINED: 601,
    MALFORMED_JSON: 701,
    ACCESS_DENIED: 403
  },
  TIPO_ASISTENCIA: {
    NUEVA: '1',
    ENTRADA: '2',
    SALIDA: '3'
  },
  TIPO_ASISTENCIA_TRABAJADOR: {
    PRESENCIAL: '1',
    REMOTO: '2',
    MIXTO: '3'
  }
};
